import useMediaQuery from '@mui/material/useMediaQuery'
import React from 'react'
import { useLocation } from 'react-router-dom'

import { getBrandingLogo, isOrganizationSettingsAllowed, User } from '@busie/utils'
import Logo from './Logo'

import Typography from '@mui/material/Typography'
import { palette } from '../../'
import { FlexContainer } from '../FlexContainer'
import { NavTabs, ProfileMenuContainer } from './components'
import MobileNavigationMenu from './MobileNavigationMenu'
import AppBarStyled from './styled/AppBarStyled'
import ToolbarStyled from './styled/ToolbarStyled'
import { HeaderProps } from './types'

export const Header: React.FC<React.PropsWithChildren<HeaderProps>> = ({
  isCustomer,
  headerLinks = [],
  authProps,
}) => {
  const { user, isAuthenticated, logout, isLoading } = authProps || {}
  const location = useLocation()
  const isDesktopSized = useMediaQuery('(min-width:1116px)')
  const isSettingsAllowed = user && isOrganizationSettingsAllowed(user as unknown as User)
  const brandingLogo = getBrandingLogo(user as unknown as User)

  const currentPageName = location.pathname.split('/').pop()?.replace(/-/g, ' ')

  React.useEffect(() => {
    if (currentPageName) {
      document.title = `Busie | ${currentPageName.charAt(0).toUpperCase() + currentPageName.slice(1)}`
    }
  }, [currentPageName])

  if (isCustomer) {
    return null
  }

  return (
    <AppBarStyled position="static">
      <ToolbarStyled>
        {isDesktopSized ? (
          <FlexContainer align="center" grow={true}>
            <Logo logoSrc={brandingLogo} />
            <NavTabs headerLinks={headerLinks} />
            <ProfileMenuContainer
              isLoading={isLoading}
              isAuthenticated={isAuthenticated}
              logout={logout}
              user={user as unknown as User}
              isSettingsAllowed={!!isSettingsAllowed}
            />
          </FlexContainer>
        ) : (
          <FlexContainer align="center" grow={true} justify="space-between">
            <Logo />
            <Typography
              variant="h1"
              textTransform="capitalize"
              fontWeight="bold"
              fontSize="24px"
              color={palette?.black?.plus10}
            >
              {currentPageName}
            </Typography>
            <MobileNavigationMenu
              headerLinks={headerLinks}
              logout={() =>
                logout?.({
                  returnTo: window.location.origin + '/login',
                })
              }
              isSettingsAllowed={!!isSettingsAllowed}
            />
          </FlexContainer>
        )}
      </ToolbarStyled>
    </AppBarStyled>
  )
}
